import React, { useState } from 'react';
import classnames from 'classnames';
import Tooltip from 'shared/components/Tooltip';
import Label from 'shared/components/Label';

const FileLabel = (props) => {
  const {
    label,
    name,
    required,
    tooltip
  } = props;

  if (label === null || label === '') {
    return null;
  }
  return (
    <Label label={label} required={required}>
      <Tooltip id={`tooltip-${name}`} title={tooltip} />
    </Label>
  );
};

const FileComponent = (props) => {
  const {
    fileName: fileNameProp,
    inputClassName: inputClassNameProp,
    name,
    groupName,
    text,
    inputId,
    isFileRequired,
    onChangeParameter,
    processFile,
  } = props;

  const [fileName, setFileName] = useState(fileNameProp);
  const inputClassName = classnames({
    'ignore-validate': !isFileRequired,
  }, inputClassNameProp);

  const uploadFile = (event) => {
    const file = event.target.files[0];
    const filename = file ? file.name : '';
    setFileName(filename);
    onChangeParameter(name, filename);
    if (processFile) processFile(file);
  };

  return (
    <div className="file-input d-grid">
      <FileLabel {...props} />
      <div className="input-group">
        <div className="input-group-prepend btn btn-primary btn-sm btn-file pt-2">
          <span>
            {text}
          </span>
          <input
            id={inputId}
            type="file"
            className={inputClassName}
            name={`${groupName}[${name}]`}
            onChange={uploadFile} />
        </div>
        <input
          className="form-control"
          onChange={() => (false)}
          value={fileName} />
      </div>
    </div>
  );
};

FileComponent.defaultProps = {
  name: 'filename',
  groupName: 'parameters',
  label: 'FileComponent',
  text: 'Upload File',
  fileName: '',
  inputId: 'filename',
  btnClassName: 'input-group',
};

export default FileComponent;